import { queryOptions } from "@tanstack/react-query";

import { listUserSpaces } from "../api/listUserSpaces";
import { getSpace } from "../api/getSpace";

const spacesQueries = {
    all: () => queryOptions({
        queryKey: ['spaces'],
        queryFn: listUserSpaces
    }),
    list: (spaceId: string) => queryOptions({
        queryKey: [...spacesQueries.all().queryKey, spaceId],
        queryFn: () => getSpace({ spaceId })
    })
}

export { spacesQueries }